<template>
    <div class="admin__messages">
        <component :is="message.type" :message="message" v-for="message in messages" :key="message.title" @remove="removeFromList"></component>
    </div>
</template>

<script>
	import {mapState, mapActions} from 'vuex';

	import {store} from "./dashboard-store";
	import DashboardMessage from "./messages/DashboardMessage.vue";
	import DashboardConsultation from "./messages/DashboardConsultation.vue";

    export default {
		name: 'Dashboard',
		components: {DashboardMessage, DashboardConsultation},
		store,
		computed: {
			...mapState([
				'messages',
			]),
		},
        methods: {
            ...mapActions([
                'getMessages',
            ]),
            removeFromList(id, nameMessage) {
               const array = {
                   'userId': id,
                   'nameMessage' : nameMessage
               };
                window.axios.post('/api/dashboard' , array)
                    .then((response) => {
                        let vm = this;
                        vm.messages.forEach(function(item, index){
                            if(!!item.button && (array.nameMessage === item.button.nameMessage)) {
                                vm.messages = vm.messages.splice(index, 1);
                            }
                        });
                    });
            },
        },
		created() {
            this.getMessages();
		}
    }
</script>
